export function ensureBuzzoolaApiAvailable(onError) {
  if (!window.BUZZOOLA && !document.getElementById('buzzlibrary_cian')) {
    const library = document.createElement('script');
    library.id = 'buzzlibrary_cian';
    library.src = 'https://tube.buzzoola.com/build/buzzlibrary.js';
    library.async = true;
    library.defer = true;
    library.onerror = event => {
      onError({
        errorMessage: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0441\u043A\u0440\u0438\u043F\u0442\u0430 'buzzlibrary.js', \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0432\u043A\u043B\u044E\u0447\u0435\u043D adBlock: \"".concat(typeof event === 'string' ? event : event.type, "\""),
        errorName: 'Error',
        errorType: 'LoadScriptError'
      });
    };
    document.body.appendChild(library);
  }
}